export default __webpack_public_path__ + "static/media/lock-small-icon.b96be759.svg";